import React from 'react'

const NoData = (props) => (
    <svg width="12" height="8" viewBox="0 0 12 8" fill={props ? props.color : '#000000'}
         xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd"
              d="M3.14804 2.94884L2.67387 3.0263C1.72462 3.18138 1 4.00703 1 5C1 6.10457 1.89543 7 3 7H9.5C10.3284 7 11 6.32843 11 5.5C11 4.75027 10.449 4.12741 9.73003 4.01739L9.07209 3.9167L8.91102 3.27088C8.58556 1.96586 7.40433 1 6 1C4.87873 1 3.89972 1.61469 3.38388 2.53025L3.14804 2.94884ZM9.8813 3.02889C9.44739 1.28903 7.87423 0 6 0C4.50324 0 3.19848 0.822097 2.51264 2.03939C1.08757 2.2722 0 3.50909 0 5C0 6.65685 1.34315 8 3 8H9.5C10.8807 8 12 6.88071 12 5.5C12 4.24893 11.081 3.2125 9.8813 3.02889Z"
              fillOpacity="0.5"/>
        <path
            d="M7.707 3.207L7 2.5L5.8535 3.6465L4.707 2.5L4 3.207L5.1465 4.3535L4 5.5L4.707 6.207L5.8535 5.0605L7 6.207L7.707 5.5L6.5605 4.3535L7.707 3.207Z"
            fillOpacity="0.5"/>
    </svg>
)

export default NoData
